import { render } from "./InternalServerError.vue?vue&type=template&id=1f307e44&scoped=true"
const script = {}

import "./InternalServerError.vue?vue&type=style&index=0&id=1f307e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f307e44"]])

export default __exports__